import React, { Component } from 'react';
import './App.css';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Brush, ResponsiveContainer } from 'recharts';
// Card
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
// App Bar
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
/* Firebaseui */
import 'firebaseui/dist/firebaseui.css';
/* React router */
import {BrowserRouter, Switch, Route, Link, Redirect} from "react-router-dom";
/* Table */
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles(theme => ({
  // Card
  card: {
    display: 'flex',
  },
  cardTile: {
    display: 'flex',
    flexDirection: 'column',
  },
  subheader: {
    display: 'flex',
    flexDirection: 'row',
  },
  menuButton: {
  //App Bar
  root: {
    flexGrow: 1,
  },
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  //Table
  tableRoot: {
    width: '100%',
  },
  tableWrapper: {
    maxHeight: 407,
    overflow: 'auto',
  },
}));

const firebase = require("firebase/app");
require("firebase/firestore");
const firebaseui = require("firebaseui");

firebase.initializeApp({
  apiKey: "AIzaSyCjUj3Qp7ZKXGKOsdwwtpY9zgnoqxcBplM",
  authDomain: "tokyoartexhibitionrank.firebaseapp.com",
  databaseURL: "https://tokyoartexhibitionrank.firebaseio.com",
  projectId: "tokyoartexhibitionrank",
  storageBucket: "",
  messagingSenderId: "877956763472",
  appId: "1:877956763472:web:4c012161a5c65d1a"
});

const db = firebase.firestore();
const collection = db.collection('exhibitions');
var heldTae = 0;

let ui = firebaseui.auth.AuthUI.getInstance();
if (!ui) {
  ui = new firebaseui.auth.AuthUI(firebase.auth());
}

const columns = [
  { id: 'item',
   label: '',
    minWidth: 120
  },
  { id: 'seiyo',
   label: '国立西洋美術館',
   minWidth: 120,
   align: 'right',
   format: value => value.toLocaleString(),
  },
  {
    id: 'tobi',
    label: '東京都美術館',
    minWidth: 120,
    align: 'right',
    format: value => value.toLocaleString(),
  },
  {
    id: 'ueno',
    label: '上野の森美術館',
    minWidth: 120,
    align: 'right',
    format: value => value.toLocaleString(),
  },
  {
    id: 'shin',
    label: '国立新美術館',
    minWidth: 120,
    align: 'right',
    format: value => value.toFixed(2),
  },
  {
    id: 'mori',
    label: '森美術館',
    minWidth: 120,
    align: 'right',
    format: value => value.toFixed(2),
  },
];

function createData(item, seiyo, tobi, ueno, shin, mori) {
  return { item, seiyo, tobi, ueno, shin, mori };
}

const rows = [
  createData('エリア', '上野公園', '上野公園', '上野公園', '六本木', '六本木'),
  createData('住所', '台東区上野公園7-7', '台東区上野公園8-36', '台東区上野公園1-2', '港区六本木7-22-2', '港区六本木6-10-1'),
  createData('最寄り駅', '上野駅', '上野駅', '上野駅', '乃木坂駅', '六本木駅/麻布十番駅'),
  createData('駐車場', '無', '無', '無', '無', '六本木ヒルズ駐車場'),
  createData('休館日', '毎週月曜日', '第1・3月曜日', '不定休', '毎週火曜日', '会期中無休'),
  createData('開館時間（基本）', '9:30～17:30', '9:30～17:30', '10:00～17:00', '10:00～18:00', '10:00～17:00'),
  createData('開館時間（延長）', '9:30～20:00', '9:30～20:00', '無', '10:00～20:00/21:00（7～9月）', '10:00～22:00'),
  createData('開館延長日', '金・土', '金', '無', '金・土', '月・水～日'),
  createData('レストラン1', '', 'MUSE', '', 'ポール・ボキューズ ミュゼ', 'THE MOON'),
  createData('レストラン2', '', 'salon', '', '', 'THE MOON Lounge'),
  createData('カフェ1', 'CAFÉすいれん', 'Art', 'cafe mori', 'サロン・ド・テ ロンド', 'THE SUN'),
  createData('カフェ2', '', '', '', 'カフェ コキーユ', ''),
  createData('カフェ3', '', '', '', 'カレ', ''),
  createData('発足年', '1959年', '旧館1926年/新館1975年', '1972年', '2007年', '2003年'),
  createData('事業主体', '国立美術館', '東京都', 'フジサンケイグループ', '国立美術館', '森ビル株式会社'),
  createData('', '独立行政法人', '公益財団法人', '公益財団法人', '独立行政法人', ''),
  createData('運営', '国立美術館', '東京都歴史文化財団', '日本美術協会', '国立美術館', '森美術館'),
  createData('設計', 'ル・コルビュジエ', '前川國男', '', '黒川紀章', 'リチャード・グラックマン'),
];

const artColumns = [
  { id: 'item',
   label: '画家',
    minWidth: 120
  },
  { id: 'seiyo',
   label: '生誕年',
   minWidth: 120,
   align: 'right',
   format: value => value.toLocaleString(),
  },
  {
    id: 'tobi',
    label: '死没年',
    minWidth: 120,
    align: 'right',
    format: value => value.toLocaleString(),
  },
  {
    id: 'ueno',
    label: '国籍',
    minWidth: 120,
    align: 'right',
    format: value => value.toLocaleString(),
  },
  {
    id: 'shin',
    label: '特色',
    minWidth: 120,
    align: 'right',
    format: value => value.toFixed(2),
  },
];

function createArtData(item, seiyo, tobi, ueno, shin, mori) {
  return { item, seiyo, tobi, ueno, shin, mori };
}

const artRows = [
  createArtData('ラファエロ', '1483', '1520', 'ウルビーノ公国（教皇領へ併合）', ''),
  createArtData('ティツィアーノ', '1490', '1576', 'イタリア', ''),
  createArtData('ブリューゲル', '1525?', '1569', 'ブラバント公国（現在のオランダ）', ''),
  createArtData('アルチンボルド', '1526', '1596', 'イタリア', ''),
  createArtData('エル・グレコ', '1541', '1614', 'ギリシャ', ''),
  createArtData('カラヴァッジョ', '15??', '1610', 'イタリア', ''),
  createArtData('ルーベンス', '1577', '1640', 'ベルギー', ''),
  createArtData('フェルメール', '1632', '1675', 'オランダ', ''),
  createArtData('ターナー', '1775', '1851', 'イギリス', ''),
  createArtData('ドーミエ', '1808', '1879', 'フランス', ''),
  createArtData('ブーダン', '1824', '1898', 'フランス', ''),
  createArtData('ピサロ', '1830', '1903', 'デンマーク', ''),
  createArtData('マネ', '1832', '1883', 'フランス', ''),
  createArtData('ホイッスラー', '1834', '1903', 'アメリカ', ''),
  createArtData('ドガ', '1834', '1917', 'フランス', ''),
  createArtData('シスレー', '1839', '1899', 'フランス', ''),
  createArtData('セザンヌ', '1839', '1906', 'フランス', ''),
  createArtData('モネ', '1840', '1926', 'フランス', ''),
  createArtData('ルノワール', '1841', '1919', 'フランス', ''),
  createArtData('ルソー', '1844', '1910', 'フランス', ''),
  createArtData('ゴーギャン', '1848', '1903', 'フランス', ''),
  createArtData('ゴッホ', '1853', '1890', 'オランダ', ''),
  createArtData('スーラ', '1859', '1891', 'フランス', ''),
  createArtData('シニャック', '1863', '1935', 'フランス', ''),
  createArtData('ロートレック', '1864', '1901', 'フランス', ''),
  createArtData('ハマスホイ', '1864', '1916', 'デンマーク', ''),
  createArtData('ミュシャ', '1860', '1939', 'チェコスロバキア', ''),
  createArtData('クリムト', '1862', '1918', 'オーストリア', ''),
  createArtData('ムンク', '1863', '1944', 'ノルウェー', ''),
  createArtData('ボナール', '1867', '1947', 'フランス', ''),
  createArtData('ヴュイヤール', '1868', '1940', 'フランス', ''),
  createArtData('モディリアーニ', '1884', '1920', 'イタリア', ''),
  createArtData('スーティン', '1893', '1943', 'フランス', ''),
  createArtData('ダリ', '1904', '1989', 'スペイン', ''),
  createArtData('バルテュス', '1908', '2001', 'フランス', ''),
];

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      activeIndex: 0,
      data: [],
      expandedIndex: 999,
      open: false,
      anchorEl: null,
      user: false,
    };
    this.handleBrush = this.handleBrush.bind(this);//bindしないと関数内のthisが動かないとか
    this.handleExpand = this.handleExpand.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleMenuOpen = this.handleMenuOpen.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleSign = this.handleSign.bind(this);
    this.handleDatabase = this.handleDatabase.bind(this);
  }

  handleBrush(i) {
    this.setState({activeIndex: i});
  }

  handleExpand(i, j) {
    if(i === this.state.expandedIndex) {
      this.setState({expandedIndex: 999});
    } else {
      const temp = db.collection(j);
      temp
        .orderBy('date')
        .get()
        .then((snapshot) => {
          const tmr = snapshot.docs.map(doc => doc.data());
          //
          this.setState(state => ({
            data: tmr,
          }));
      });
      this.setState({expandedIndex: i});
    }
  }

  handleAdd(authorVal, textVal){
    const now = nowToString();
    const post = db.collection(this.state.items[this.state.expandedIndex].name);
    post.add({author: authorVal, text: textVal, date: now});
    this.state.data.push({author: authorVal, text: textVal, date: now});
    this.setState({data: this.state.data});
  }

  handleMenuOpen(x) {
    this.setState({ open: true, anchorEl: x });
  }

  handleMenuClose() {
    this.setState({ open: false, anchorEl: null });
  };

  handleSign(i) {
    this.setState({user: i});
  }

  handleDatabase(x) {
    if(x === 0) {// Home
      heldTae = 0;
      collection
        .where('visitor', '>=', 0)
        .orderBy('visitor','desc')
        .get()
        .then((snapshot) => {
          const tms = snapshot.docs.map(doc => doc.data());
          tms.sort((a,b) => b.held - a.held);
          for(let k of Object.keys(tms)) {
            if (tms[k].held > 0) {
              heldTae++;
            }
          }
          //
          var cnt = 1;
          for(let k of Object.keys(tms)) {
            if (k < heldTae) {
              tms[k].rank = '開催中' + cnt;
              cnt++;
            } else {
              tms[k].rank = k - heldTae + 1;
            }
          }
          this.setState(state => ({
            items: tms,
            activeIndex: heldTae,
          }));
      });
    } else {// Next
      collection
        .where('visitor', '<', 0)
        .orderBy('visitor','desc')
        .get()
        .then((snapshot) => {
          const tms = snapshot.docs.map(doc => doc.data());
          for(let k of Object.keys(tms)) {
            tms[k].rank = '開催予定';
          }
          this.setState(state => ({
            items: tms,
          }));
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <BrowserRouter>
          <a name="title"></a>
          <div className={useStyles.root}>
            <AppBar position="static">
              <Toolbar>
                <MenuAction open={this.state.open} anchorEl={this.state.anchorEl} user={this.state.user}
                  dataVila={(i) => {this.handleSign(i);}}
                  dataMoro={(x) => {this.handleMenuOpen(x);}}
                  dataPeco={() => {this.handleMenuClose();}}
                  dataNego={(x) => {this.handleDatabase(x);}}
                />
                <Typography variant="h6" className={useStyles.title}>東 京 美 術 展 ラ ン キ ン グ</Typography>
              </Toolbar>
            </AppBar>
          </div>
          <Switch>
            <Route exact path="/">
              <h2 className={classSelect(0)}>Tokyo Art Exhibition Rank</h2>
              <div>
                <LeftAxes/>
                <RightAxes/>
              </div>
              <div>
                <Chart value={this.state.items} brush={this.state.activeIndex} dataHoge={(i) => {this.handleBrush(i);}} />
              </div>
              <div>
                <TweetList value={this.state.items} data={this.state.data} expanded={this.state.expandedIndex} user={this.state.user}
                dataFuga={(i, j) => {this.handleExpand(i, j);}} dataWego={(a, t) => {this.handleAdd(a, t);}}/>
              </div>
            </Route>
            <Route path="/next">
              <h2 className={classSelect(0)}>Upcoming Art Exhibitions</h2>
              <div>
                <TweetList value={this.state.items} data={this.state.data} expanded={this.state.expandedIndex} user={this.state.user}
                dataFuga={(i, j) => {this.handleExpand(i, j);}} dataWego={(a, t) => {this.handleAdd(a, t);}}/>
              </div>
            </Route>
            <Route path="/museum">
              <h2 className={classSelect(0)}>Tokyo Art Museums</h2>
              <div>
                <SimpleTable/>
              </div>
            </Route>
            <Route path="/artist">
              <h2 className={classSelect(0)}>Artists</h2>
              <div>
                <ArtSimpleTable/>
              </div>
            </Route>
            <Redirect to="/"/>
          </Switch>
        </BrowserRouter>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.handleDatabase(0);
  }
}

/* Menu */
class MenuAction extends React.Component {
  handleMenuOpen = (event) => {
    this.props.dataMoro(event.currentTarget);
    return false;
  }

  handleMenuClose = () => {
    this.props.dataPeco();
    return false;
  }

  handleLogin = () => {
    if(this.props.user) {
      console.log("サインインしています");
      /* handleMenuClose */
      this.props.dataPeco();
      return false;
    }
    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          console.log("サインインしました");
          this.props.dataVila(true);
          /* handleMenuClose */
          this.props.dataPeco();
          return false;
        },
        uiShown: () => {
        },
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInFlow: 'popup',
      signInSuccessUrl: '/',
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      tosUrl: 'http://narusat.web.fc2.com/index.html',
      privacyPolicyUrl: 'http://narusat.web.fc2.com/privacy_policy.html',
    };
    ui.start('#firebaseui-auth-container', uiConfig);
  }

  handleLogout = () => {
    if(!this.props.user) {
      console.log("サインインしていません");
      /* handleMenuClose */
      this.props.dataPeco();
      return false;
    }
    firebase.auth().signOut().then(() => {
      console.log("サインアウトしました");
      this.props.dataVila(false);
    }).catch(function(error) {
      console.log(`サインアウト時にエラーが発生しました (${error})`);
    });
    /* handleMenuClose */
    this.props.dataPeco();
    return false;
  }

  handleHome = () => {
    this.props.dataNego(0);
    /* handleMenuClose */
    this.props.dataPeco();
    return false;
  }

  handleNext = () => {
    this.props.dataNego(1);
    /* handleMenuClose */
    this.props.dataPeco();
    return false;
  }

  render() {
    return (
      <div>
        <IconButton edge="start" className={useStyles.menuButton} color="inherit"
          aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleMenuOpen}>
          <MenuIcon/>
        </IconButton>
        <Menu id="simple-menu" anchorEl={this.props.anchorEl} keepMounted open={this.props.open} onClose={this.handleMenuClose}>
          <MenuItem onClick={this.handleHome}><Link to="/">ホーム</Link></MenuItem>
          <MenuItem onClick={this.handleNext}><Link to="/next">今後開催される美術展</Link></MenuItem>
          <MenuItem onClick={this.handleMenuClose}><Link to="/museum">都内の美術館</Link></MenuItem>
          <MenuItem onClick={this.handleMenuClose}><Link to="/artist">画家一覧</Link></MenuItem>
          <MenuItem onClick={this.handleLogin}>サインイン</MenuItem>
          <div>
            <div id="firebaseui-auth-container" />
          </div>
          <MenuItem onClick={this.handleLogout}>サインアウト</MenuItem>
        </Menu>
      </div>
    )
  }
}

/* Chart */
class LeftAxes extends React.Component {
    render() {
    return (
      <span className={classSelect(1)}>{leftLabel()}</span>
    )
  }
}

class RightAxes extends React.Component {
    render() {
    return (
      <span className={classSelect(2)}>{rightLabel()}</span>
    )
  }
}

class Chart extends React.Component {
  handleClick = (data, index) => {
    var br = this.props.brush;// 左端
    var t = null;
    var si = br + index - heldTae + 1;
    t = '#tag' + si;
    document.location = t;
    return false;
  }

  handleChange = (wtf) => {
    this.props.dataHoge(wtf.startIndex);
    return false;
  }

  render() {
    return (
      <ResponsiveContainer width={classSelect(3)} height="100%" minWidth={200} minHeight={200}>
        <BarChart
          data={this.props.value}
          margin={{
            top: 0, right: 1, left: 20, bottom: 0,
          }}
          >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="rank" />
          <YAxis yAxisId="left" orientation="left" stroke="#1dcd00" hide={switchHide()} domain={[0, 1000000]}/>
          <YAxis yAxisId="right" orientation="right" stroke="#55acee" hide={switchHide()} domain={[0, 20000]}/>
          <Tooltip content={<CustomTooltip value={this.props.value}/>} />
          <Legend />
          <Brush dataKey="rank" startIndex={heldTae} endIndex={switchEndIndex()} height={30} stroke="#8884d8" onChange={this.handleChange}/>
          <Bar yAxisId="left" dataKey="visitor" fill="#1dcd00" onClick={this.handleClick}/>
          <Bar yAxisId="right" dataKey="average" fill="#55acee" onClick={this.handleClick}/>
        </BarChart>
      </ResponsiveContainer>
    )
  }
}

class CustomTooltip extends React.Component {
  render() {
    const { active } = this.props;
    const data = this.props.value;
    if (active) {
      const { payload, label } = this.props;
      if (label > 0) {
        return (
            <div className="custom-tooltip">
              <p >{data[label + heldTae - 1].name}</p>
              <p className="visitor-color">{`visitor : ${visitorNum(payload[0].value)}`}</p>
              <p className="average-color">{`average : ${averageNum(payload[1].value)}`}</p>
            </div>
        );
      } else {
        return (
            <div className="custom-tooltip">
              <p >{data[label.slice(3) - 1].name}</p>
              <p className="visitor-color">{`visitor : ${visitorNum(data[label.slice(3) - 1].visitor)}`}</p>
            </div>
        );
      }
    }
    return null;
  }
}

/* Card */
class TweetList extends React.Component {
  handleExpand = (i, j) => {
    this.props.dataFuga(i, j);
    return false;
  }

  handleAdd = (e) => {
    if(this.props.user) {
      e.preventDefault(); //これを書かないとリダイレクトされてしまう
      var authorVal = e.target.title.value.trim();
      var textVal = e.target.comment.value.trim();
      if (!textVal || !authorVal) {
        return;
      }
      this.props.dataWego(authorVal, textVal);
      e.target.title.value = '';
      e.target.comment.value = '';
      return false;
    } else {
      e.preventDefault(); //これを書かないとリダイレクトされてしまう
      alert("コメントの投稿を行う際は、サインインが必要です。");
      return false;
    }
  }

  render() {
    return (
      <React.Fragment>
          {this.props.value.map((item, index) => (
            <div>
              <a name={makeTag(item.rank)}/>
              <Card className={useStyles.card}>
                  <CardHeader
                    avatar={
                      <img alt="" src={item.img} className={classSelect(4)}/>
                    }
                    title={
                      <CardContent className={useStyles.cardTile}>
                        <span className={classSelect(5)}>{item.rank}</span>
                        <br></br>
                        <span className={classSelect(6)}><i class="fas fa-walking"></i>　{visitorNum(item.visitor)}</span>
                        <span className={classSelect(7)}><i class="fas fa-walking"></i>　{averageNum(item.average)}</span>
                        <br></br>
                        <br></br>
                        <span className={classSelect(8)}><a href={item.website}>{item.name}</a></span>
                      </CardContent>
                    }
                    subheader={
                      <CardContent className={useStyles.subheader1}>
                        <span className={classSelect(9)}><i class="far fa-clock"></i> {item.date}</span>
                        <span className={classSelect(9)}><i class="fas fa-landmark"></i> {item.place}</span>
                        <br></br>
                        <br></br>
                        <span className={classSelect(10)}>{item.memo}</span>
                      </CardContent>
                    }
                  />
                  <CardActions disableSpacing>
                    <IconButton aria-expanded={isExpanded(index, this.props.expanded)}>
                      <ExpandMoreIcon onClick={() => { this.handleExpand(index, item.name); }}/>
                    </IconButton>
                    <Typography className={useStyles.title}>
                      コ メ ン ト
                    </Typography>
                  </CardActions>
                  <Collapse in={isExpanded(index, this.props.expanded)} timeout="auto" unmountOnExit>
                    <form className={classSelect(11)} autocomplete="off" onSubmit={this.handleAdd}>
                      <div>
                        <input name="title" type="text" placeholder="お名前" maxlength="40" className={classSelect(12)} />
                      </div>
                      <div>
                        <textarea name="comment" type="text" placeholder="コメント" maxlength="400" wrap="soft" className={classSelect(13)} />
                      </div>
                      <input type="submit" value="送信する" className="btn btn-primary"/>
                    </form>
                    <div>
                      {this.props.data.map(c => (
                        <Comment author={c.author} text={c.text} date={c.date}/>
                      ))}
                    </div>
                  </Collapse>
              </Card>
            <a href="#title"><h3 className={classSelect(0)}><i class="fas fa-sort-up"></i></h3></a>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

/* Comment */
class Comment extends React.Component {
  render() {
    return (
      <div>
        <Card className={classSelect(14)}>
          <CardContent>
            <Typography variant="body1" gutterBottom color="textSecondary">
              {this.props.date}
            </Typography>
            <Typography variant="h6" gutterBottom>
              {this.props.author}
            </Typography>
            <Typography variant="body1" gutterBottom color="textSecondary">
              {this.props.text}
            </Typography>
          </CardContent>
        </Card>
      </div>
    )
  }
}

/* Table */
function SimpleTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  function handleChangePage(event, newPage) {
    setPage(newPage);
  }
  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  return (
    <Paper className={useStyles.tableRoot}>
      <div className={useStyles.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map(column => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

/* Art Table */
function ArtSimpleTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  function handleChangePage(event, newPage) {
    setPage(newPage);
  }
  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  return (
    <Paper className={useStyles.tableRoot}>
      <div className={useStyles.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {artColumns.map(column => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {artRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {artColumns.map(column => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={artRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

/* Misc */
function nowToString() {
  var v = null;
  var d = new Date();
  var year  = d.getFullYear();
  var month = d.getMonth() + 1;
  var day  = d.getDate();
  var hour = ( d.getHours()   < 10 ) ? '0' + d.getHours()   : d.getHours();
  var min  = ( d.getMinutes() < 10 ) ? '0' + d.getMinutes() : d.getMinutes();
  var sec  = ( d.getSeconds() < 10 ) ? '0' + d.getSeconds() : d.getSeconds();
  var v = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
  return v;
}

function isExpanded(index, expandedIndex) {
  var v = null;
  if (index === expandedIndex) {
    v = true;
  } else {
    v = false;
  }
  return v;
}

function visitorNum(visitor) {
  var v = null;
  if (visitor <= 0) {
    v = "?人";
  } else {
    v = visitor.toLocaleString() + "人";
  }
  return v;
}

function averageNum(average) {
  var a = null;
  if (average === 0) {
    a = "?人/日";
  } else {
    a = average.toLocaleString() + "人/日";
  }
  return a;
}

function makeTag(rank) {
  var t = "tag" + rank;
  return t;
}

function switchEndIndex() {
  var t = null;
  if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
    t = 6;
  } else {
  	t = 11;
  }
  return t;
}

function switchHide() {
  var t = null;
  if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
    t = true;
  } else {
  	t = false;
  }
  return t;
}

function leftLabel() {
  var t = null;
  if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
    t = "1,000,000人";
  } else {
  	t = "";
  }
  return t;
}

function rightLabel() {
  var t = null;
  if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
    t = "20,000人/日";
  } else {
  	t = "";
  }
  return t;
}

function classSelect(num) {
  var t = null;
  if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
    switch( num ) {
      case 0:
        t = "title-center-mb";
        break;
      case 1:
        t = "left-label-mb";
        break;
      case 2:
        t = "right-label-mb";
        break;
      case 3:
        t = "95%";
        break;
      case 4:
        t = "avatar-style-mb";
        break;
      case 5:
        t = "rank-style-mb";
        break;
      case 6:
        t = "visitor-style-mb";
        break;
      case 7:
        t = "average-style-mb";
        break;
      case 8:
        t = "name-style-mb";
        break;
      case 9:
        t = "date-style-mb";
        break;
      case 10:
        t = "memo-style-mb";
        break;
      case 11:
        t = "comment-form-mb";
        break;
      case 12:
        t = "form-name-mb";
        break;
      case 13:
        t = "form-comment-mb";
        break;
      case 14:
        t = "comment-list-mb";
        break;
      default:
        break;
    }
  } else {
    switch( num ) {
      case 0:
        t = "title-center-pc";
        break;
      case 1:
        t = "left-label-pc";
        break;
      case 2:
        t = "right-label-pc";
        break;
      case 3:
        t = "100%";
        break;
      case 4:
        t = "avatar-style-pc";
        break;
      case 5:
        t = "rank-style-pc";
        break;
      case 6:
        t = "visitor-style-pc";
        break;
      case 7:
        t = "average-style-pc";
        break;
      case 8:
        t = "name-style-pc";
        break;
      case 9:
        t = "date-style-pc";
        break;
      case 10:
        t = "memo-style-pc";
        break;
      case 11:
        t = "comment-form-pc";
        break;
      case 12:
        t = "form-name-pc";
        break;
      case 13:
        t = "form-comment-pc";
        break;
      case 14:
        t = "comment-list-pc";
        break;
      default:
        break;
    }
  }
  return t;
}

export default App;
